import React from 'react';
import Button from '../../Button';

const ProductDetailHeader = ({ 
    recrawling,
    statusConfig,
    onBack,
    onRecrawl,
    onUpdate,
    showUpdateButton
}) => {
    return (
        <div className="flex items-center justify-between mb-6">
            <div className="flex items-center">
                <button
                    onClick={onBack}
                    className="flex items-center text-gray-600 hover:text-gray-800"
                >
                    <span className="mr-4">◀︎</span>
                    <h1 className="text-xl font-bold text-gray-800">제품 상세 정보</h1>
                </button>
            </div>
            <div className="flex items-center gap-3">
                {/* <Button
                    onClick={onRecrawl}
                    disabled={recrawling}
                    variant="outterNavy"
                    size="sm"
                >
                    {recrawling ? '재크롤링 중...' : '재크롤링 ↩︎'}
                </Button> */}
                <span className={`px-3 py-1 rounded text-sm font-medium ${statusConfig.className}`}>
                    {statusConfig.text}
                </span>
                {showUpdateButton && onUpdate && (
                    <Button
                        onClick={onUpdate}
                        className="bg-slate-400 hover:bg-slate-700 text-white"
                        size="sm"
                    >
                        업데이트
                    </Button>
                )}
            </div>
        </div>
    );
};

export default ProductDetailHeader;
